export const Error4040 = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="justify-content-center align-content-center">
        <div className="col-md-12 text-center">
          <h1 className="display-1">404</h1>
          <p className="lead display-4">Página no encontrada</p>
          <p className="lead display-6">Lo sentimos, la página que estás buscando no existe.</p>
          <a href="/home/main" className="badge fs-4 bg-primary-subtle border border-primary-subtle text-primary-emphasis rounded-pill">
            Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
}